import { COLOR_PALETTE } from "@constants";
import { useAppSelector, getActiveVariant } from "@lib/store";
import { SensorIcon } from "@map/logic";

export const useAvailabilityColors = () => {
  const activeVariant = useAppSelector(getActiveVariant);
  const isVariantB = activeVariant === "B";

  const colors: Record<SensorIcon, string> = {
    full: COLOR_PALETTE.functional.red.default,
    busy: COLOR_PALETTE.creativePink[500],
    lively: COLOR_PALETTE.energizingYellow[600],
    quiet: isVariantB ? COLOR_PALETTE.connectingGreen[400] : COLOR_PALETTE.special.green,
    unknown: COLOR_PALETTE.mapiqBlack[300],
  };

  return colors;
};
